export enum ApplicationErrorType
{
    ERROR_HTTP = "HTTP error",
    ERROR_DEEPLINK = "Deeplink error",
    ERROR_RUNTIME = "Runtime JS error"
}